import { useEffect, useMemo, useState } from 'react';
import { searchTasks, useMyTagsForTasks, useAssigneeReadReceipts } from './api';
import { useAuth } from '../auth/AuthProvider';
import TaskCard from './TaskCard';
import type { Task } from './types';

export default function BuscarPage() {
  const { profile } = useAuth();
  const [q, setQ] = useState('');
  const [results, setResults] = useState<Task[]>([]);
  const [loading, setLoading] = useState(false);

  const taskIds = useMemo(() => results.map((t) => t.id), [results]);
  const { tagsByTask } = useMyTagsForTasks(taskIds, profile?.id);
  const receipts = useAssigneeReadReceipts(results, profile?.id);

  useEffect(() => {
    const term = q.trim();
    if (term.length < 2) {
      setResults([]);
      return;
    }
    setLoading(true);
    const t = setTimeout(async () => {
      const found = await searchTasks(term);
      setResults(found);
      setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div style={{ padding: '32px 40px', maxWidth: 920, margin: '0 auto' }}>
      <h1 style={{ fontSize: 26, fontWeight: 700, color: '#0f172a', margin: 0 }}>Buscar</h1>
      <p style={{ color: '#64748b', fontSize: 14, marginTop: 4 }}>
        Busca por palabras del asunto o de los mensajes.
      </p>

      <input
        autoFocus
        type="text"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Ej. colaboradores, sync, vencimiento…"
        style={{
          width: '100%',
          marginTop: 18,
          marginBottom: 22,
          padding: '12px 16px',
          fontSize: 15,
          border: '1px solid #cbd5e1',
          borderRadius: 10,
          outline: 'none',
          background: '#fff',
        }}
      />

      {loading && <p style={{ color: '#94a3b8', fontSize: 14 }}>Buscando…</p>}
      {!loading && q.length >= 2 && results.length === 0 && (
        <p style={{ color: '#94a3b8', fontSize: 14 }}>Sin coincidencias.</p>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {results.map((t) => <TaskCard key={t.id} task={t} tags={tagsByTask[t.id]} readReceipt={receipts[t.id]} />)}
      </div>
    </div>
  );
}
